// src/components/CourseManagerDialog.jsx
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    Button,
    Chip,
    Divider,
    Grid,
    Switch,
    FormControlLabel,
  } from "@mui/material";
  import {
    Chat,
    Close,
    Add,
    CheckBoxOutlineBlank,
    CheckBox,
  } from "@mui/icons-material";
import { on } from "events";
  
  export default function CourseManagerDialog({
    open,
    onClose,
    onSave,
    selectedCourses = [],
    availableCourses = [],
    onToggleChatAll,
    onToggleChat,
    onRemoveCourse,
    onAddCourse,
    onlyView = false,
    title,
  }) {
    const categories = [...new Set(availableCourses.map((item) => item.category))].sort();
    const dialogTitle = title || (!onlyView ? "Gestionar Cursos del Lote" : "Ver Cursos del Lote");
  
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontSize: "1rem" }}>
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          {/* Cursos Seleccionados */}
          {!onlyView && (
          <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
              mb: 1,
            }}
          >
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{ fontSize: "0.85rem" }}
            >
              Cursos Seleccionados:
            </Typography>
            {selectedCourses.length > 0 && (
              <Box sx={{ display: "flex", gap: 0.8 }}>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<CheckBoxOutlineBlank sx={{ fontSize: 14 }} />}
                  onClick={() => onToggleChatAll(false)}
                  sx={{ fontSize: "0.7rem", py: 0.3 }}
                >
                  Desactivar Chat Todos
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<CheckBox sx={{ fontSize: 14 }} />}
                  onClick={() => onToggleChatAll(true)}
                  sx={{
                    fontSize: "0.7rem",
                    py: 0.3,
                    backgroundColor: "#10B981",
                    "&:hover": { backgroundColor: "#059669" },
                  }}
                >
                  Activar Chat Todos
                </Button>
              </Box>
            )}
          </Box>
  
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              mb: 2,
              minHeight: 50,
              maxHeight: 250,
              overflowY: "auto",
              p: 1.5,
              border: "1px solid #E5E7EB",
              borderRadius: 1.5,
              backgroundColor: "#F9FAFB",
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#F3F4F6",
                borderRadius: "2px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#D1D5DB",
                borderRadius: "2px",
                "&:hover": {
                  backgroundColor: "#9CA3AF",
                },
              },
            }}
          >
            {selectedCourses.length === 0 ? (
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ alignSelf: "center", fontSize: "0.75rem" }}
              >
                No hay cursos seleccionados
              </Typography>
            ) : (
              selectedCourses.map((curso) => (
                <Box
                  key={curso.code}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1,
                    backgroundColor: "white",
                    borderRadius: 1.5,
                    border: "1px solid #E5E7EB",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                    <Chip
                      label={`${curso.code} - ${curso.name}`}
                      size="small"
                      sx={{
                        backgroundColor: "#10B981",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Box>
  
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={curso.chatEnabled}
                          onChange={() => onToggleChat(curso.code)}
                          size="small"
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#10B981",
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                              {
                                backgroundColor: "#10B981",
                              },
                          }}
                        />
                      }
                      label={
                        <Chat
                          sx={{
                            fontSize: 14,
                            color: curso.chatEnabled ? "#10B981" : "#9CA3AF",
                          }}
                        />
                      }
                      sx={{ m: 0 }}
                    />
  
                    <Button
                      size="small"
                      color="error"
                      onClick={() => onRemoveCourse(curso.code)}
                      sx={{
                        minWidth: "auto",
                        p: 0.5,
                        borderRadius: "50%",
                        "&:hover": {
                          backgroundColor: "rgba(244, 67, 54, 0.1)",
                        },
                      }}
                    >
                      <Close sx={{ fontSize: 14 }} />
                    </Button>
                  </Box>
                </Box>
              ))
            )}
          </Box>

          </>
          )}
  
          <Divider sx={{ my: 1.5 }} />
  
          {/* Cursos Disponibles */}
          <Typography
            variant="body2"
            fontWeight="bold"
            sx={{ mb: 1.5, fontSize: "0.85rem" }}
          >
            Cursos Disponibles:
          </Typography>
  
          {/* Organizado por categorías */}
          <Box sx={{ mb: 1.5 }}>
            {categories.map((category, index) => (
              <Box key={category + index}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{
                    mb: 0.8,
                    fontWeight: 600,
                    fontSize: "0.75rem",
                    display: "block",
                  }}
                >
                  {category}
                </Typography>
  
                <Grid container spacing={0.8} sx={{ mb: 1.5 }}>
                  {availableCourses
                    .filter((curso) => curso.category === category)
                    .map((curso) => (
                      <Grid item xs={12} sm={6} md={4} key={curso.code}>
                        <Chip
                          label={`${curso.code} - ${curso.name}`}
                          onClick={() => onAddCourse(curso)}
                          icon={<Add sx={{ fontSize: 12 }} />}
                          size="small"
                          sx={{
                            backgroundColor: "#F3F4F6",
                            "&:hover": { backgroundColor: "#E5E7EB" },
                            cursor: "pointer",
                            width: "100%",
                            justifyContent: "flex-start",
                            "& .MuiChip-label": {
                              fontSize: "0.7rem",
                            },
                          }}
                        />
                      </Grid>
                    ))}
                </Grid>
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          {!onlyView ? (
            <>
            <Button onClick={onClose} size="small">
            Cancelar
          </Button>
          <Button
            onClick={onSave}
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#10B981" }}
            //disabled={tempCursosSeleccionados.length === 0}
          >
            Guardar Cambios
          </Button>
            </>
          ):(
            <>
            <Button onClick={onClose} size="small">
            Cerrar
          </Button>
         
            </>
          )}
          
        </DialogActions>
      </Dialog>
    );
  }
  